import { useImmerAtom } from 'jotai-immer';
import { useCallback } from 'react';
import { dataMonitorPageStateAtom } from '../datamonitor_list_atoms';
import { DataMonitorTab } from '../../datamonitor_const';

type UseDataMonitorStoreReturn = {
    activeTab: DataMonitorTab;
    facilityVal: string;
    facilityOptions: any[];
    facilityValid: boolean;
    loading: boolean;
    deepLinkMonitorType: string | null;
    setActiveTab: (tab: DataMonitorTab) => void;
    setFacility: (val: string) => void;
};

export const useDataMonitorStore = (): UseDataMonitorStoreReturn => {
    const [state, setState] = useImmerAtom(dataMonitorPageStateAtom);

    const setActiveTab = useCallback(
        (tab: DataMonitorTab): void => {
            setState(draft => {
                draft.activeTab = tab;
            });
        },
        [setState],
    );

    const setFacility = useCallback(
        (val: string): void => {
            setState(draft => {
                draft.facility.val = val;
                draft.facility.valid = !!val && val !== 'NONE' && val !== '';
            });
        },
        [setState],
    );

    return {
        activeTab: state.activeTab,
        facilityVal: state.facility.val,
        facilityOptions: state.facility.options,
        facilityValid: state.facility.valid,
        loading: state.loading,
        deepLinkMonitorType: state.deepLinkMonitorType,
        setActiveTab,
        setFacility,
    };
};
